import { formattedLevelBattery } from "../../components/formatted/FormattedText";
import { formattedTime } from "../../components/formatted/FormattedDateAndTime";
import { truncateText } from "../../components/formatted/FormattedText";
import { useTranslation } from "react-i18next";

const getLastUpdateFromCamera = (camera) => {
  const match = camera.image_url?.match(/pictures\/(.*?)-camera/);
  if (match?.[1]) {
    return new Date(match[1].replace(/_/g, ":") + "Z");
  }
  if (camera.lastUpdate) {
    return new Date(camera.lastUpdate);
  }
  return null;
};

const formatCameraId = (id) => {
  const withoutSideSuffix = String(id || "").replace(/_[lr]$/i, "");
  return `AK_${withoutSideSuffix.slice(-5).toUpperCase()}`;
};

const formatCameraLastScanDate = (date, language) => {
  const locale = language?.startsWith("fr")
    ? "fr-FR"
    : language?.startsWith("es")
      ? "es-ES"
      : language?.startsWith("se") || language?.startsWith("sv")
        ? "sv-SE"
        : "en-US";
  return new Date(date).toLocaleDateString(locale, {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
};

const CameraRow = ({ data, battery, setShowedCamera, setIsModalView }) => {
  const { t, i18n } = useTranslation();
  const lastUpdateDate = getLastUpdateFromCamera(data);
  const cameraBattery = battery !== undefined ? battery : {};

  const handleRowClick = () => {
    setShowedCamera(data);
    setIsModalView(true);
  };

  return (
    <article className="table-standard-row" onClick={handleRowClick}>
      <div className="table-standard-row-cell">{formatCameraId(data._id)}</div>

      <div className="table-standard-row-cell">
        {lastUpdateDate ? (
          <div className="camera-last-scan">
            <span className="camera-last-scan__date">
              {formatCameraLastScanDate(lastUpdateDate, i18n.language)}
            </span>
            <span className="camera-last-scan__time">
              {formattedTime(lastUpdateDate)}
            </span>
          </div>
        ) : (
          <span className="camera-last-scan__empty">—</span>
        )}
      </div>

      <div className="table-standard-row-cell">
        {data?.address && data?.address.length > 0 && (
          <span>{truncateText(data?.address[0].name, 25)}</span>
        )}
      </div>

      <div className="table-standard-row-cell">
        <span className="camera-battery-cell">
          {cameraBattery !== undefined &&
          cameraBattery !== null &&
          !isNaN(cameraBattery) ? (
            <>
              {formattedLevelBattery(cameraBattery)}
              {`${Math.trunc(cameraBattery)}%`}
            </>
          ) : (
            <span className="camera-last-scan__empty">
              {t("Unknown level")}
            </span>
          )}
        </span>
      </div>
    </article>
  );
};

export default CameraRow;
